import { AST } from '@handlebars/parser';
import { joinWithSpaces } from 'utils/stringHelpers';
import { COMMENT_PREFIX, COMMENT_SUFFIX } from '../constants';
import { serializeHandlebar } from '../../../utils/serializeHandlebar';

export class CommentStatementSerializer {
  static serialize = (statement: AST.CommentStatement) =>
    serializeHandlebar(
      joinWithSpaces([COMMENT_PREFIX, statement.value, COMMENT_SUFFIX]),
      statement.strip,
    );
}
